export const SET_CONTENT_HTML = 'SET_CONTENT_HTML'

export const ADD_SOURCE = 'ADD_SOURCE'
export const EDIT_SOURCE = 'EDIT_SOURCE'
export const SET_SOURCE_ORDER_INDEX = 'SET_SOURCE_ORDER_INDEX'

export const ADD_LINK = 'ADD_LINK'

export const SET_AUTH_DATA = 'SET_AUTH_DATA'
export const SET_DOCS = 'SET_DOCS'
export const SET_DOC_DATA = 'SET_DOC_DATA'
export const RENAME_DOC = 'RENAME_DOC'
export const SET_DOC_SAVED = 'SET_DOC_SAVED'
export const CREATE_DOC = 'CREATE_DOC'
export const SET_CURRENT_DOC = 'SET_CURRENT_DOC'
export const UPDATE_CURRENT_DOC = 'UPDATE_CURRENT_DOC'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js